import { Backdrop, Close, Dialog, Wrapper } from './Dialog';
import { AnimatedIconCircle, Content, Footer, Group, Header, Headline, IconCircle, Inner, Paragraph, } from './Content';
export const Modal = {
    Dialog,
    Wrapper,
    Backdrop,
    AnimatedIconCircle,
    IconCircle,
    Content,
    Header,
    Group,
    Footer,
    Headline,
    Paragraph,
    Close,
    Inner,
};
//# sourceMappingURL=index.js.map